module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings
    },
    on: {
      "save": _vm.save,
      "show": _vm.showingDialog,
      "hide": _vm.hidingDialog
    }
  }, [_c('v-menu', {
    attrs: {
      "slot": "header",
      "right": "",
      "offset-y": ""
    },
    slot: "header",
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("keyboard_arrow_down")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.debugRecord
    }
  }, [_c('v-list-item-title', [_vm._v("Debug Record")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pr-4 pl-4 pb-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('ElementControl', {
    attrs: {
      "element": _vm.page
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(true) ? _c('DeleteButton', {
    on: {
      "delete": _vm.deleteButtonClicked
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62dc2e62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/system/DataDialog.vue
// module id = 2580
// module chunks = 1